import React, { useRef } from 'react';
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
} from '@chakra-ui/react';

interface IReassignToDoctorModal {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    onSubmitDraft: () => void;
}

export const DraftOrFinish = (props: IReassignToDoctorModal): JSX.Element => {
    const { isOpen } = props;
    const { onClose, onSubmit, onSubmitDraft } = props;
    const cancelRef = useRef<HTMLButtonElement>(null);

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            isCentered
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        ¿Desea guardar borrador o finalizar consulta?
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}>
                            Regresar
                        </Button>
                        <Button
                            color={'white'}
                            backgroundColor={'primary.300'}
                            _hover={{ backgroundColor: 'primary.300' }}
                            onClick={onSubmit}
                            ml={3}
                        >
                            Finalizar
                        </Button>
                        <Button
                            color={'white'}
                            backgroundColor={'secondary.300'}
                            _hover={{ backgroundColor: 'secondary.300' }}
                            onClick={onSubmitDraft}
                            ml={3}
                        >
                            Guardar
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};
